import React, { type DetailedHTMLProps, type HTMLAttributes, forwardRef } from "react";
import { twJoin } from "tailwind-merge";

interface TrackProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  active: boolean;
}

export const Track = forwardRef<HTMLDivElement, TrackProps>(function TrackComponent({ active, className, ...restProps }, ref) {
  return <div ref={ref} className={twJoin(className, "transition-colors duration-200 border-primary-500", !active ? "border-t-0.5" : "border-t-[2.5px]")} {...restProps} />;
});
